import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, MenuItem, Typography } from '@mui/material';
import { US_STATES } from '@shared/constants/states';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimRadioGroup, ClaimTextField } from '../fields';

// Helper to convert boolean to string for RadioGroup, handling null/undefined properly
const boolToRadioValue = (value: boolean | undefined | null): string => {
  if (value === true) return 'true';
  if (value === false) return 'false';
  return '';
};


export const Box10_PatientCondition: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">{"10. IS PATIENT'S CONDITION RELATED TO:"}</Typography>

      <Box mb={0.5} display="flex" flexDirection="column" gap={1}>
        <Typography variant="caption">a. EMPLOYMENT?</Typography>
        <Controller
          name="conditionRelated.employment"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimRadioGroup
              field={field}
              fieldState={fieldState}
              options={[
                { value: true, label: 'YES' },
                { value: false, label: 'NO' },
              ]}
              valueConverter={boolToRadioValue}
              onChangeConverter={(val) => val === 'true' ? true : val === 'false' ? false : undefined}
              row
            />
          )}
        />
      </Box>

      <Box display="flex" gap={1} flexWrap="wrap" alignItems="flex-start" mb={0.5}>
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography variant="caption">b. AUTO ACCIDENT?</Typography>
          <Controller
            name="conditionRelated.autoAccident"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimRadioGroup
                field={field}
                fieldState={fieldState}
                options={[
                  { value: true, label: 'YES' },
                  { value: false, label: 'NO' },
                ]}
                valueConverter={boolToRadioValue}
                onChangeConverter={(val) => val === 'true' ? true : val === 'false' ? false : undefined}
                row
              />
            )}
          />
        </Box>
        <Box flex={1} display="flex" flexDirection="column" gap={1}>
          <Typography variant="caption">PLACE (State):</Typography>
          <Controller
            name="conditionRelated.autoAccidentState"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                select
                size="small"
                fullWidth
                sx={{ minWidth: '100px' }}
              >
                <MenuItem value="">--</MenuItem>
                {Object.entries(US_STATES).map(([code]) => (
                  <MenuItem key={code} value={code}>
                    {code}
                  </MenuItem>
                ))}
              </ClaimTextField>
            )}
          />
        </Box>
      </Box>

      <Box mb={0.5} display="flex" flexDirection="column" gap={1}>
        <Typography variant="caption">c. OTHER ACCIDENT?</Typography>
        <Controller
          name="conditionRelated.otherAccident"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimRadioGroup
              field={field}
              fieldState={fieldState}
              options={[
                { value: true, label: 'YES' },
                { value: false, label: 'NO' },
              ]}
              valueConverter={boolToRadioValue}
              onChangeConverter={(val) => val === 'true' ? true : val === 'false' ? false : undefined}
              row
            />
          )}
        />
      </Box>

      <Typography variant="caption">d. CLAIM CODES</Typography>
      <Controller
        name="conditionRelated.claimCodes"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
          />
        )}
      />
    </>
  );
};